var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_526_email_campaign_outline",
    "data-name": "#526_email_campaign_outline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.56,
    y: 113.45,
    width: 149.06,
    height: 88.22,
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,202.66H114.56a1,1,0,0,1-1-1V113.45a1,1,0,0,1,1-1H263.62a1,1,0,0,1,1,1v88.21A1,1,0,0,1,263.62,202.66Zm-148.06-2H262.62V114.45H115.56Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.09 148.12 114.56 201.66 263.62 201.66 189.09 148.12",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,202.66H114.56a1,1,0,0,1-.59-1.81l74.53-53.54a1,1,0,0,1,1.17,0l74.53,53.54a1,1,0,0,1-.58,1.81Zm-146-2H260.51l-71.42-51.31Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.09 166.99 114.56 113.45 263.62 113.45 189.09 166.99",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.09,168a1,1,0,0,1-.59-.19L114,114.26a1,1,0,0,1,.59-1.81H263.62a1,1,0,0,1,.58,1.81L189.67,167.8A1,1,0,0,1,189.09,168Zm-71.43-53.54,71.43,51.31,71.42-51.31Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.45,
    y: 131.28,
    width: 149.06,
    height: 88.22,
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,220.5H129.45a1,1,0,0,1-1-1V131.28a1,1,0,0,1,1-1H278.51a1,1,0,0,1,1,1V219.5A1,1,0,0,1,278.51,220.5Zm-148.06-2H277.51V132.28H130.45Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.98 165.95 129.45 219.5 278.51 219.5 203.98 165.95",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.51,220.5H129.45a1,1,0,0,1-.58-1.82l74.53-53.54a1,1,0,0,1,1.17,0l74.53,53.54a1,1,0,0,1-.59,1.82Zm-145.95-2H275.41L204,167.18Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.98 184.82 129.45 131.28 278.51 131.28 203.98 184.82",
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,185.82a1,1,0,0,1-.58-.18l-74.53-53.55a1,1,0,0,1,.58-1.81H278.51a1,1,0,0,1,.59,1.81l-74.53,53.55A1,1,0,0,1,204,185.82Zm-71.42-53.54L204,183.59l71.43-51.31Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.48,162.93c-.06.26-.11.55-.16.89a5.14,5.14,0,0,0-.09.88.91.91,0,0,0,.15.52.65.65,0,0,0,.58.23,1.77,1.77,0,0,0,.84-.23,2,2,0,0,0,.73-.72,4.27,4.27,0,0,0,.53-1.25,7.07,7.07,0,0,0,.2-1.79,7.27,7.27,0,0,0-.52-2.82,5.7,5.7,0,0,0-1.45-2,5.92,5.92,0,0,0-2.21-1.25,9.24,9.24,0,0,0-2.8-.41,7.89,7.89,0,0,0-3,.56,6.81,6.81,0,0,0-2.35,1.58,7.19,7.19,0,0,0-1.51,2.41,8.44,8.44,0,0,0-.53,3,7.9,7.9,0,0,0,.59,3.15A6.72,6.72,0,0,0,199.1,168a7.53,7.53,0,0,0,2.5,1.48,9.14,9.14,0,0,0,3.13.52,8.61,8.61,0,0,0,2.8-.43,7.42,7.42,0,0,0,2.26-1.2h2.94a9.5,9.5,0,0,1-3.6,3,10.65,10.65,0,0,1-4.61,1,11,11,0,0,1-4-.74,10.41,10.41,0,0,1-3.3-2A9.35,9.35,0,0,1,195,166.5a9.59,9.59,0,0,1-.82-4,9.76,9.76,0,0,1,.8-4,9.92,9.92,0,0,1,2.2-3.16,10.22,10.22,0,0,1,3.25-2.1,10.68,10.68,0,0,1,7.43-.18,9.38,9.38,0,0,1,3,1.69,8.57,8.57,0,0,1,2.16,2.77,8.41,8.41,0,0,1,.81,3.76,8.14,8.14,0,0,1-.33,2.46,6,6,0,0,1-.86,1.76,4.69,4.69,0,0,1-1.17,1.18,6.21,6.21,0,0,1-1.31.7,6.54,6.54,0,0,1-1.26.33,7.28,7.28,0,0,1-1,.1,2.33,2.33,0,0,1-1.61-.46,1.46,1.46,0,0,1-.51-1h-.05a6,6,0,0,1-1.34,1,4.22,4.22,0,0,1-2.08.46,3.72,3.72,0,0,1-1.57-.34,3.54,3.54,0,0,1-1.21-.92,4.08,4.08,0,0,1-.79-1.42,5.56,5.56,0,0,1-.28-1.82,6.87,6.87,0,0,1,.37-2.26,6.19,6.19,0,0,1,1.06-1.92,4.86,4.86,0,0,1,1.67-1.34,5,5,0,0,1,2.24-.49,4,4,0,0,1,1.78.34,2.37,2.37,0,0,1,1.11,1.18h.06l.21-1.2h2.51Zm-2.49-.72a3,3,0,0,0-.48-1.76,1.68,1.68,0,0,0-1.5-.7,2.31,2.31,0,0,0-1.95,1,3.85,3.85,0,0,0-.73,2.36,4.09,4.09,0,0,0,.09.85,2.15,2.15,0,0,0,.28.77,1.64,1.64,0,0,0,.56.55,1.82,1.82,0,0,0,.92.21,2.87,2.87,0,0,0,1.38-.3,2.47,2.47,0,0,0,.87-.76,2.92,2.92,0,0,0,.44-1A5.52,5.52,0,0,0,206,162.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.4,80.5H212.8a13.11,13.11,0,0,0-13.11,13.11v36a13.11,13.11,0,0,0,13.11,13.11h4.45v14.85l16.3-14.85H277.4a13.11,13.11,0,0,0,13.11-13.11v-36A13.11,13.11,0,0,0,277.4,80.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.25,158.56a.93.93,0,0,1-.4-.09,1,1,0,0,1-.6-.91V143.71H212.8a14.13,14.13,0,0,1-14.11-14.11v-36A14.13,14.13,0,0,1,212.8,79.5h64.6a14.13,14.13,0,0,1,14.11,14.11v36a14.13,14.13,0,0,1-14.11,14.11H233.94l-16,14.58A1,1,0,0,1,217.25,158.56ZM212.8,81.5a12.13,12.13,0,0,0-12.11,12.11v36a12.12,12.12,0,0,0,12.11,12.11h4.45a1,1,0,0,1,1,1v12.58L232.88,142a1,1,0,0,1,.67-.26H277.4a12.12,12.12,0,0,0,12.11-12.11v-36A12.13,12.13,0,0,0,277.4,81.5Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.82,114.66h4.5a0,0,0,0,1,0,0V132.8a2.25,2.25,0,0,1-2.25,2.25h0a2.25,2.25,0,0,1-2.25-2.25V114.66A0,0,0,0,1,227.82,114.66Z",
    transform: "translate(-22.22 55.07) rotate(-13.03)",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.85,135.84a3.17,3.17,0,0,1-1.71-.49,3.25,3.25,0,0,1-1.45-2l-4.09-17.67a1,1,0,0,1,.75-1.2l4.38-1a1.07,1.07,0,0,1,.76.13,1,1,0,0,1,.44.62L235,131.86a3.22,3.22,0,0,1-.41,2.46,3.27,3.27,0,0,1-2,1.44A3.16,3.16,0,0,1,231.85,135.84Zm-5.07-19.66,3.86,16.7a1.2,1.2,0,0,0,.55.77,1.23,1.23,0,0,0,.95.16h0a1.2,1.2,0,0,0,.77-.55,1.23,1.23,0,0,0,.16-.95l-3.86-16.69Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.83,
    cy: 105.99,
    r: 6.45,
    fill: "#f56132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83,113.44a7.45,7.45,0,1,1,7.4-8.3h0a7.46,7.46,0,0,1-6.55,8.25A8.24,8.24,0,0,1,260.83,113.44Zm0-12.9c-.2,0-.41,0-.62,0a5.45,5.45,0,1,0,6,4.79h0A5.46,5.46,0,0,0,260.83,100.54Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.38,87.46l4.24,36.9s-13.1-6-20.4-5.19L227.32,121a11.09,11.09,0,0,1-2.53-22l15.9-1.83C248,96.3,259.38,87.46,259.38,87.46Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.62,125.36a1,1,0,0,1-.42-.09c-.13-.06-12.94-5.9-19.87-5.1L227.44,122A12.12,12.12,0,0,1,214,111.36,12.1,12.1,0,0,1,224.68,98l15.9-1.83c6.93-.8,18.08-9.38,18.19-9.47a1,1,0,0,1,1.61.68l4.23,36.9a1,1,0,0,1-1,1.11Zm-18.92-7.27c6,0,14.27,3.2,17.73,4.66L258.59,89.3c-3.32,2.41-11.76,8.14-17.79,8.83L224.91,100a10.09,10.09,0,1,0,2.3,20l15.89-1.82A13.78,13.78,0,0,1,244.7,118.09Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.57,98.18l2.53,22-6.78.78a11.09,11.09,0,0,1-2.53-22Z",
    fill: "#ffbc0e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,122.08A12.09,12.09,0,0,1,224.68,98l6.78-.78a1,1,0,0,1,.74.21,1.05,1.05,0,0,1,.37.67l2.53,22a1,1,0,0,1-.88,1.1l-6.78.78A11.24,11.24,0,0,1,226,122.08Zm4.67-22.79-5.79.67a10.09,10.09,0,0,0,2.3,20.05l5.79-.67Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.84,106.4a1,1,0,0,1-.11-2l5.39-.61a1,1,0,0,1,1.1.89,1,1,0,0,1-.88,1.1l-5.39.61Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.12,110.15a1,1,0,0,1-1-.89,1,1,0,0,1,.88-1.1l5.39-.61a1,1,0,1,1,.22,2l-5.38.6Z",
    fill: "#093f68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2,93.72a1,1,0,0,1-.94-.64,1,1,0,0,1,.58-1.29l6.84-2.59a1,1,0,0,1,.71,1.87l-6.84,2.59A1.12,1.12,0,0,1,269.2,93.72Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,105.63a1,1,0,0,1-.12-2l9.2-1.12a1,1,0,0,1,.24,2l-9.2,1.11Z",
    fill: "#dfeaef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,120.28a1,1,0,0,1-.4-.09l-5.82-2.57a1,1,0,1,1,.81-1.83l5.82,2.57a1,1,0,0,1,.51,1.32A1,1,0,0,1,278.94,120.28Z",
    fill: "#dfeaef"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f5b3737ed89a4882d417140f74d1312a.svg";
export { ForwardRef as ReactComponent };